import Bus from "./bus";
import { redirectUrl } from "@/config";
const fetch = axios.create({
  // baseURL: '',
  timeout: 20000,
  withCredentials: true, //开启携带cookies  false为关闭
});

fetch.defaults.withCredentials = true;

// 请求拦截器
fetch.interceptors.request.use(
  (config) => {
    config.headers.common["Content-Type"] = "application/json";
    if (localStorage.authorization) {
      config.headers.common["authorization"] = localStorage.authorization;
    }
    return config;
  },
  (erro) => Promise.reject(erro)
);
// 响应拦截器
fetch.interceptors.response.use(
  (response) => {
    // fetch.default.headers.common['Cookie'] = response.headers
    const { status, data } = response;
    // 只返回code为1时的数据，其他状态不返回
    if (status === 200) {
      if (data.code === 0 || data.code === 1) {
        return data;
      } else if ([1001, 1002].indexOf(data.code) > -1) {
        localStorage.removeItem("authorization");
        Bus.$emit("_Error", "登陆过期请重新登录");
        // window.location.href= redirectUrl;
        return;
      }
    }
    Bus.$emit("_Error", data.msg);
    return Promise.reject(data);
  },
  (error) => {
    const res = error.response;
    if (res.status === 403) {
      alert("登录失效，请重新登录");
      // const msg = res.data.msg || '请重新登录';
      // Bus.$emit('_Unauth', msg);
      window.location.href = redirectUrl;
    }
    return Promise.reject(error);
  }
);

export default fetch;
